import floorPlanAnalyticsReducer from './floorPlanAnalytics'

let reducers = {
  floorPlanAnalytics: floorPlanAnalyticsReducer,
}

export default reducers